import cxs from 'cxs';

export default cxs({
  ' > *:not(:last-child)': {
    marginBottom: '15px'
  }
});